module.exports = __webpack_public_path__ + "static/media/icon-transfer.f0cbfbb8.png";